module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-introduction element-with-heading",
    attrs: {
      "id": "introduction"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_vm._v("INTRODUCTION")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "introduction-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('b', [_c('i', [_vm._v("Three amazing novels in one bundle.")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_c('i', [_vm._v("Warning: this is for grown folks only!")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_c('i', [_vm._v(".")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_c('i', [_vm._v("WAS IT GOOD FOR YOU TOO?")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Tailan and Delvin complicated their lives by bringing another woman into the relationship to bear his children. Once the surrogate was two months along, she turned the tables by issuing a heartbreaking ultimatum. Now seven years later on a Midwest book tour, fate has given Delvin, now a wealthy actor and author, four days to right old wrongs. He’ll use everything in his power to win Tailan back. Unfortunately, Tailan is harboring a secret that she’s kept not only from him but from the entire world.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('b', [_c('i', [_vm._v("OPEN DOOR MARRIAGE")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("USA TODAY Bestselling Author, Naleighna Kai, tells the dynamic love triangle of a chance encounter that lands wealthy NBA star, Dallas Avery, back in the arms of Alicia, the woman of his dreams. A woman he hasn’t seen in years. A woman he soon discovers is his fiancée’s long-lost aunt!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But Tori, isn’t ready to give up all that she’s worked for in their relationship, so she makes him a shocking offer—go through with the wedding and she’ll still allow him to be with the one woman he now can’t seem to do without. Everyone will get a little of what they want. . . and maybe a whole lot of what they don’t.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('b', [_c('i', [_vm._v("RICH WOMAN’S FETISH")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Gina learns that one of her surrogate daughters has been forced into the illicit world of drugs and prostitution. When the police and FBI turn a blind eye, Gina risks the anger of her former sponsors and lovers to have their children search for the younger sister they know nothing about. One daughter turns to a criminal mastermind to help locate the teen; another puts her career in jeopardy when she seeks justice in her own deadly way. If exploring the darker underworld of the lengths couples will go to have a child, and the sensual journey that one woman takes to survive makes you even slightly curious, then you’ll love USA TODAY Bestselling Author Naleighna Kai’s Rich Woman’s Fetish.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b118d9e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introduction.vue
// module id = 63
// module chunks = 0